export enum AddView_GroupType {
    GROUP       = 'group',
    SEPARATOR   = 'separator'
}

export type AddView_Group = {
    type            : AddView_GroupType
    id?             : ID
    icon?           : string
    title?          : string
    skipItemsList?  : boolean // skip showing group items list and show first item form - vic: nado bilo item a ne group delat' type ...
    items?          : (AddView_OptionConfig|null)[]
}

export type AddView_OptionConfig = {
    typeId                  : any
    iconSvg?                : string
    title                   : string
    description?            : string
    isPro?                  : boolean   // item requires license upgrade
    proFeature?             : any       // to show specific upgrade modal if necessary
    alreadyExists?          : boolean   // for single views to mark they're already added

    onClick?                : func      // use this to redefine default click

    formParams?             : any       // any additional params to use in formComponent
    formComponent?          : any       // render form component on click instead of calling any function
}

// GROUPS

export const AddView_GroupTasks = {
    type        : AddView_GroupType.GROUP,
    id          : 'tasks',
    icon        : 'i5-tasks',
    title       : 'Tasks',
}

export const AddView_GroupEvents = {
    type        : AddView_GroupType.GROUP,
    id          : 'events',
    icon        : 'i5-calendar',
    title       : 'Calendar & Events',
}

export const AddView_GroupFinance = {
    id          : 'finance',
    type        : AddView_GroupType.GROUP,
    icon        : 'i5-expenses-light',
    title       : 'Finance',
}

export const AddView_GroupPlanning = {
    type        : AddView_GroupType.GROUP,
    id          : 'planning',
    icon        : 'i5-gantchart2',
    title       : 'Planning',
}


export const AddView_GroupCollaboration = {
    type        : AddView_GroupType.GROUP,
    id          : 'collaboration',
    icon        : 'i5-users',
    title       : 'Collaboration',
}

export const AddView_GroupProject = {
    type        : AddView_GroupType.GROUP,
    id          : 'portfolio',
    // icon        : 'ii5-assets',
    icon        : 'i5-project', //i5-portfolio
    title       : 'Projects',

}

export const AddView_GroupEmbed = {
    type        : AddView_GroupType.GROUP,
    id          : 'embed',
    icon        : 'i5-embeded-code',
    title       : 'Link / Embed View',
}

export const AddView_GroupMore = {
    type        : AddView_GroupType.GROUP,
    id          : 'more',
    icon        : 'i5-more',
    title       : 'More',
}

// TASKS